import Hero from '../sections/Hero';
import Story from '../sections/Story';
import Services from '../sections/Services';
import Projects from '../sections/Projects';
import Statement from '../sections/Statement';
import Metrics from '../sections/Metrics';
import Reviews from '../sections/Reviews';
import Contact from '../sections/Contact';
import { Seo } from '../lib/seo';

export default function Home() {
  return (
    <>
      <Seo
        title="Revive Builders | Multifamily Contractor & Property Services | San Antonio & Austin"
        description="One vendor, twelve service lines: general contracting, renovations, make-readys, exteriors, demolition, restoration, cleaning, landscaping, and tree services for multifamily and commercial properties across San Antonio and Austin. (210) 393-1759."
        path="/"
      />
      <Hero />
      <Story />
      <Services />
      <Projects />
      <Statement />
      <Metrics />
      <Reviews />
      <Contact />
    </>
  );
}
